import z from "zod"

export const loginSchema = z.object({
	email: z.email().trim(),
	password: z.string().min(8),
})

export type LoginSchema = typeof loginSchema
export type LoginInput = z.infer<typeof loginSchema>

export const registerSchema = z.object({
	name: z.string().trim().min(1).max(120),
	email: z.email().trim(),
	password: z.string().min(8).max(128),
})

export type RegisterSchema = typeof registerSchema
export type RegisterInput = z.infer<typeof registerSchema>

export const googleCallbackSchema = z.object({
	code: z.string(),
	state: z.string(),
})

export type GoogleCallbackSchema = typeof googleCallbackSchema
export type GoogleCallbackInput = z.infer<typeof googleCallbackSchema>
